import React from 'react';
import styles from '../Operations.module.css';

interface MGMAComponent extends React.FC {
  title?: string;
  kpiHyperlink?: string;
  actionTitle?: string;
  actionHyperlink?: string;
}

/**
 * MGMA - Mango Assortment
 * KPI information component
 */
const MGMA: MGMAComponent = () => {
  return (
    <div className={styles.container}>
      <div className={styles.sectionTitle}>
        Metric Description
      </div>

      <div className={styles.sectionContent}>
        Assortment Opportunity measures your store&apos;s incremental annual sales opportunity if it carried everything (Ace SKUs only) that sold well in other peer stores but are not carried in your store.
      </div>

       <div className={styles.sectionContent}>
        For a SKU to appear on this list:
      </div>

      <div className={styles.indented}>
            • Not in your inventory file<br/>
         •  High potential of increased annual sales <br/>
      </div>
      <br />

      <div className={styles.sectionContent}>
        Peer Store Sales are based on the following criteria: 
      </div>

        <div className={styles.indented}>
          • Add- Good Selling SKUs carried by less than 80% of your peers<br/>
          • Add Popular- SKU is carried by 80% or more peer stores<br/>
          • Add Associated- an associated SKU to one you already carry.<br/>
          <div className={styles.indented}>Example: you carry the mop but not its refill</div>
          • New RSC Item- good-selling SKUs added to your RSC within the past year<br/>
          • Top Product Group- this SKU is the #1 ranked SKU in its Product Group based on the median annual gross profit dollars.
        </div>
      <br />

      <div className={styles.sectionTitle}>
        Supporting Details
      </div>

      <div className={styles.sectionContent}>
        SKU-level detail is found in your Assortment Report and your MEGA report.<br /><br />
        For example, if your store is showing a 3.2% Assortment Opportunity then you could see an annual sales increase of 3.2% if it added more SKUs.<br /><br />
        This metric does not take similar SKUs into full account, so it is unlikely your store would experience real a 3.2% sales increase.<br /><br />
        However, this metric is consistently measured across all stores, so it is a great gauging additional sales opportunity your store has compared to targets and peers.
      </div>

      <div className={styles.sectionTitle}>
        Goal
      </div>

      <div className={styles.sectionContent}>
        Less than 3% (potential annual sales increase from missing SKUs).<br/>
        <br/>
        Your potential sales increase being low is a great thing because you aren&apos;t missing out on good selling SKUs.
      </div>

       <div className={styles.sectionTitle}>
        Drill Down
      </div>

      <div className={styles.sectionContent}>
        Mango Assortment grid which allows you to analyze and order any suggested items. 
      </div>

      <div className={styles.sectionTitle}>
        Learn More
      </div>

      <div className={styles.sectionContent}>
        1) In the upper-right corner of any ACENET screen, click Cart. The Shopping Cart Special Orders Tab displays.<br/>
        2) Click the Mango Assortment tab Note: If you are not on the Mango program, then the tab will not display in the Shopping Cart.<br/>
        3) Click the Mango Assortment Basket Name to view listing of SKUs or to submit the basket select the checkbox and click Checkout.<br/>
        <br/>
        <div className={styles.indented}>
          <strong>Note:</strong> You must have checkout permission to submit the basket.
        </div>
        <br/>
        4) Review the items in the basket and make any necessary changes.<br/>
        5) If desired, to remove all the cost information displayed in the grid, click any Cost field.<br/>
        6) To print the information currently displayed in the grid, click Print.<br/>
        7) If needed, use the Snooze feature to temporarily remove specific items from your recommendations list for 180 days.<br/>
        8) To submit all the items in this basket to Ace Corporate, verify there is a checkmark in the left column for every item, and then click Checkout.<br/>
        9) Confirmation screen will display to confirm the basket was successfully submitted.
      </div>
    </div>
  );
};

MGMA.title = 'Mango Assortment';
MGMA.kpiHyperlink = 'https://hc.mangoreport.com/hc/en-us/articles/17349586172685-Assortment';
MGMA.actionTitle = 'Mango Assortment Shopping Cart';
MGMA.actionHyperlink = 'dynamicURL:ACENET:current';
export default MGMA;

